import { render, staticRenderFns } from "./FoodSoldOut.vue?vue&type=template&id=59d26ba0&scoped=true&"
import script from "./FoodSoldOut.vue?vue&type=script&lang=js&"
export * from "./FoodSoldOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d26ba0",
  null
  
)

export default component.exports